import type { FC } from 'react';
import type { TextProps, TooltipProps } from '@eqi-investimentos/react';
import { Text, Tooltip } from '@eqi-investimentos/react';

export const TextOverflow: FC<TextOverflowProps> = ({
  children,
  charLimit,
  tooltipStyles,
  className,
  ...textProps
}) => (
  <Tooltip
    closeOnClick={false}
    label={children}
    {...tooltipStyles}
    sx={{
      maxWidth: '300px',
      width: 'max-content',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      p: '0 10px',
      borderRadius: '2px',
      ...tooltipStyles?.sx,
    }}
  >
    <Text
      as="span"
      className={className}
      color="content.primary"
      {...textProps}
      {...(!charLimit && {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      })}
    >
      {charLimit && children.length > charLimit
        ? `${children.substring(0, charLimit).trim()}...`
        : children}
    </Text>
  </Tooltip>
);

type TextOverflowProps = Partial<Omit<TextProps, 'children'>> & {
  children: string;
  charLimit?: number;
  className?:
    | 'hide-monetary-center'
    | 'hide-monetary-right'
    | 'hide-monetary-left'
    | '';
  tooltipStyles?: Omit<TooltipProps, 'children'>;
};
